export const randomNumber = max => Math.floor(Math.random() * (max - 1));
